
import { defineComponent } from 'vue';
import { translate } from 'CoreHome';

const __default__ = defineComponent({
  props: {
    aiName: {
      type: String,
      required: true,
    },
    aiColor: {
      type: String,
      default: '#3450a3',
    },
  },
  computed: {
    waitingText(): string {
      return translate('ChatGPT_WaitingForResponse');
    },
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "221431fb": (_ctx.aiColor)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__